import dayjs from 'dayjs'

const isBeforeNow = (timestamp: Parameters<typeof dayjs>[0]): boolean => dayjs(timestamp).isBefore(dayjs())

export default isBeforeNow
